import React, { FC } from 'react';
import LogoImage from '../common/assets/images/logo.svg';

export interface LogoProps {}

export const Logo: FC<LogoProps> = () => {
    return <img className="w-[167px] h-[56px]" src={LogoImage} alt="Baro" />;
};
